// **React Imports
import { memo } from 'react'

// **MUI Imports
import { Box, Typography } from '@mui/material'

// **Components Imports
import Icon from '../icon'
import LinkedinVerifyButton from '../linkedin-verify-button'

// styles
const STYLES = {
  containerSx: {
    py: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(135deg, var(--background-default) 0%, #eff6ff 100%)',
    border: '1px solid var(--divider)',
    borderRadius: '24px',
    position: 'relative',
    overflow: 'hidden'
  },
  bgIconTopSx: {
    position: 'absolute',
    top: -20,
    right: -20,
    opacity: 0.05,
    transform: 'rotate(-15deg)',
    pointerEvents: 'none'
  },

  bgIconBottomSx: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    opacity: 0.05,
    transform: 'rotate(-15deg)',
    pointerEvents: 'none'
  },

  iconWrapperSx: {
    width: 100,
    height: 100,
    borderRadius: '30px',
    background: 'var(--primary-main)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 6,
    boxShadow: '0 20px 40px rgba(10, 102, 194, 0.25)',
    color: '#fff'
  },

  titleSx: {
    fontWeight: 800,
    mb: 2,
    color: 'text.primary'
  },

  descSx: {
    color: 'text.secondary',
    maxWidth: 500,
    mb: 8,
    fontSize: '14px',
    lineHeight: 1.6,
    textAlign: 'center'
  },

  verifyBtnSx: {
    py: 3,
    px: 8,
    borderRadius: '14px',
    fontSize: '1.1rem',
    fontWeight: 700,
    boxShadow: '0 10px 20px rgba(10, 102, 194, 0.2)'
  }
}

const LinkedinRequiredCard = () => {
  // constant styles
  const {
    containerSx,
    bgIconTopSx,
    bgIconBottomSx,
    iconWrapperSx,
    titleSx,
    descSx,
    verifyBtnSx
  } = STYLES

  return (
    <Box className="practice-empty-state linkedin-required" sx={containerSx}>
      <Box sx={bgIconTopSx}>
        <Icon icon="mdi:linkedin" style={{ fontSize: '200px' }} />
      </Box>
      <Box sx={bgIconBottomSx}>
        <Icon icon="mdi:linkedin" style={{ fontSize: '200px' }} />
      </Box>

      <Box className="icon-wrapper" sx={iconWrapperSx}>
        <Icon
          icon="streamline-sharp:startup-remix"
          style={{ fontSize: '50px' }}
        />
      </Box>

      <Typography variant="h4" sx={titleSx}>
        Unlock Prep Mode
      </Typography>
      <Typography sx={descSx}>
        Verify your LinkedIn profile to access personalized AI practice
        interviews, profile scoring, detailed feedback, and realistic interview
        simulations tailored to your career journey.
      </Typography>

      <LinkedinVerifyButton size="large" sx={verifyBtnSx} />
    </Box>
  )
}

export default memo(LinkedinRequiredCard)
